import { expVal, expValEquals } from '@confluence/feature-experiments';

export const isStickyInViewMode = (tableElement: HTMLElement | null) => {
	return Boolean(tableElement?.getAttribute('mode') === 'stick');
};

export const isStickyInEditMode = (tableElement: HTMLElement | null) => {
	const isStickyHeaderExperimentEnabled =
		expValEquals(
			'platform_editor_table_sticky_header_improvements',
			'cohort',
			'test_with_overflow',
		) && expVal('platform_editor_table_sticky_header_patch_11', 'isEnabled', false);

	if (isStickyHeaderExperimentEnabled) {
		return Boolean(tableElement?.classList.contains('pm-table-row-native-sticky-active'));
	}
	return Boolean(tableElement?.classList.contains('pm-table-sticky'));
};

export const getIsSticky = (tableElement: HTMLElement | null, isEditor: boolean | undefined) =>
	isEditor ? isStickyInEditMode(tableElement) : isStickyInViewMode(tableElement);
